import { cx } from '@freightapi/ui'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useConsoleI18n } from '../lib/locale'

/**
 * Webhooks is two screens about one subject (M3-06): the endpoints you subscribed, and the log of
 * what was actually sent to them. They belong together — a developer who finds that nothing
 * arrived checks the endpoint and then the deliveries, in that order — so the sub-navigation lives
 * here and `src/nav.ts` keeps one line for the whole section (M3-01, acceptance criterion).
 */
export const Route = createFileRoute('/_app/webhooks')({ component: Webhooks })

const TABS = [
  { to: '/webhooks', label: 'webhooks.nav.endpoints' },
  { to: '/webhooks/deliveries', label: 'webhooks.nav.deliveries' },
] as const

function Webhooks() {
  const { t } = useConsoleI18n()

  return (
    <section className="flex flex-col gap-6">
      <h1 className="font-semibold text-display text-ink">{t('nav.webhooks.label')}</h1>
      <nav aria-label={t('nav.webhooks.label')}>
        <ul className="flex list-none flex-wrap gap-1 p-0">
          {TABS.map((tab) => (
            <li key={tab.to}>
              <Link
                to={tab.to}
                // `/webhooks` is a prefix of `/webhooks/deliveries`, so the endpoints tab has to
                // ask for an exact match or both tabs light up on the deliveries page.
                activeOptions={{ exact: tab.to === '/webhooks' }}
                className={cx(
                  'block min-h-touch rounded-card px-3 py-2 font-medium text-body text-muted',
                  'hover:bg-surface',
                )}
                activeProps={{ className: 'bg-brand-50 text-brand-700' }}
              >
                {t(tab.label)}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </section>
  )
}
